module.exports = __webpack_public_path__ + "img/imgborder.a784b680.png";